var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _vm._m(0)
}
var staticRenderFns = [
  function () {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "scrap-step-wrap" }, [
      _c("div", { staticClass: "go-modal-inner overflow-y-scroll" }, [
        _c("div", { staticClass: "scrap-step-contents" }, [
          _c("div", [
            _c("span", [_c("i", { staticClass: "go-icon-32 go-icon-check" })]),
            _vm._v(" "),
            _c("strong", [
              _vm._v("에이전트 생성이 "),
              _c("b", [_vm._v("완료")]),
              _vm._v("되었습니다."),
            ]),
          ]),
          _vm._v(" "),
          _c("ul", { staticClass: "go-info-list" }, [
            _c("li", { staticClass: "go-list-item" }, [
              _vm._v("등록된 채널에 대한 수집이 시작되었습니다."),
            ]),
            _vm._v(" "),
            _c("li", { staticClass: "go-list-item" }, [
              _vm._v(
                "수집을 원치 않는 경우, 'My page > 수집 채널 관리' 페이지에서 수정하실 수 있습니다."
              ),
            ]),
          ]),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }